<twc-dialog-skeleton>
  <ng-container dialog-title i18n>Import quote</ng-container>
  <ng-container dialog-content>
    <twc-alert-card [type]="AlertType.NOTICE" class="display-block mb-16">
      <span class="twc-typography-body-1 twc-color-primary-typeface">
        This feature uses AI. Review details after creation.
      </span>
    </twc-alert-card>
    <form
      id="importQuoteForm"
      class="pb-24"
      [formGroup]="form"
      (ngSubmit)="importQuote()"
    >
      <div class="form-field mb-13">
        <label for="quoteType" i18n>Quote type</label>
        <mat-form-field appearance="outline" class="full-width large-field">
          <mat-select
            id="quoteType"
            formControlName="isQuickQuote"
            placeholder="Select type"
          >
            <mat-option [value]="true">Quick</mat-option>
            <mat-option [value]="false">Full</mat-option>
          </mat-select>
          <mat-error form-field-errors fieldName="Type"></mat-error>
        </mat-form-field>
      </div>

      <div class="form-field full-width mt-12">
        <span class="mb-7 twc-typography-body-1 twc-color-primary-typeface"
          >Attachment</span
        >
        <twc-multi-file-uploader
          formControlName="documents"
          [allowedFileTypes]="acceptedFormats"
          [maxFileSize]="maxFileSize"
        ></twc-multi-file-uploader>
      </div>
    </form>
  </ng-container>
  <ng-container dialog-actions>
    <button mat-stroked-button mat-dialog-close i18n>Cancel</button>
    <button
      form="importQuoteForm"
      class="twc-color-white"
      [loading]="busy()"
      [disabled]="!form.valid"
      color="primary"
      type="submit"
      mat-flat-button
      i18n
    >
      Import
    </button>
  </ng-container>
</twc-dialog-skeleton>
